export var RaysLoadingStatus;
(function (RaysLoadingStatus) {
    RaysLoadingStatus[RaysLoadingStatus["NotLoaded"] = 0] = "NotLoaded";
    RaysLoadingStatus[RaysLoadingStatus["Initializing"] = 1] = "Initializing";
    RaysLoadingStatus[RaysLoadingStatus["Loading"] = 2] = "Loading";
    RaysLoadingStatus[RaysLoadingStatus["Loaded"] = 3] = "Loaded";
    RaysLoadingStatus[RaysLoadingStatus["Error"] = 4] = "Error";
})(RaysLoadingStatus || (RaysLoadingStatus = {}));
export const SIM_EMPTY = 1;
export const SIM_SUN = 2;
export const SIM_SUN4D = 4;
export const SIM_VVA = 8;
export const SIM_NOISE = 16;
export const SIM_WIND = 32;
export const SIM_TARGET = 64;
export const SAVED = 128;
export const MIXED = 256;
